<template>
  <section id="home">
    <div class="wrapper-fl-searchbar">
      <div class="searchbar">
        <Searchbar></Searchbar>
      </div>
      <div class="filmliste">
        <DbOutput />
      </div>
      <div v-if="this.$store.state.selectedFestivalCard !== 0" class="wrap-modal">
        <Modal @close="closeModal"/>
      </div>
    </div>
  </section>
</template>
<script>

import DbOutput from '../components/DbOutput.vue';
import Searchbar from '../components/Searchbar.vue';
import Modal from '../components/Modal.vue';

export default {
  components: {
    DbOutput,
    Searchbar,
    Modal,
  },
  data() {
    return {
      isModalVisible: false,
      modalValues: [],
      nameValue: '',
    };
  },
  methods: {
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    getModalId(id) {
      this.modalValues = id;
      this.nameValue = id.title_en;
      this.showModal();
    },
  },
};

</script>
